<template>
    <div class="flex min-h-screen bg-white">
        <div class="flex flex-col justify-center flex-1 px-6 py-12 sm:px-6 lg:flex-none md:w-1/2 lg:w-1/3 lg:px-20 xl:px-24">
            <div class="w-full max-w-sm mx-auto">
                <div>
                    <img
                        class="w-auto"
                        src="/img/logo.png"
                        alt="Workflow"
                    />
                </div>
                <div class="mt-8">
                    <div class="mt-6">
                        <form
                            action="/login"
                            method="POST"
                        >
                            <div>
                                <label
                                    for="username"
                                    class="block text-sm font-medium leading-5 text-gray-700"
                                >
                                    Username
                                </label>
                                <div class="mt-1 rounded-md shadow-sm">
                                    <input
                                        v-model="username"
                                        type="text"
                                        required
                                        class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                                    />
                                </div>
                            </div>

                            <div class="mt-6">
                                <label
                                    for="password"
                                    class="block text-sm font-medium leading-5 text-gray-700"
                                >
                                    Password
                                </label>
                                <div class="mt-1 rounded-md shadow-sm">
                                    <input
                                        v-model="password"
                                        type="password"
                                        required
                                        class="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                                    />
                                </div>
                            </div>

                            <div class="mt-6">
                                <span class="block w-full rounded-md shadow-sm">
                                    <button
                                        @click="login"
                                        type="button"
                                        class="flex justify-center w-full px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                                    >
                                        Login
                                    </button>
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="relative flex-1 hidden w-0 md:block">
            <img
                class="absolute inset-0 object-cover w-full h-full"
                src="/img/background.jpg"
                alt=""
            />
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            username: "",
            password: ""
        };
    },
    methods: {
        login() {
            this.$store
                .dispatch("auth/LOGIN", {
                    username: this.username,
                    password: this.password
                })
                .then(success => {
                    this.$router.push("/");
                });
        }
    }
};
</script>
